import { isMobileDevice } from "../compat";

//
// This object handles the default click behaviour, some of which is controlled
// via the "setClickBehavior" configuration.
//
export class DefaultHandler {
  clickConfig = null;

  constructor(viewerImpl, navapi, utilities) {
    this._viewerImpl = viewerImpl;
    this._navapi = navapi;
    this._utilities = utilities;
  }
  getNames()
  {
    return ["default"];
  }

  getName()
  {
    return this.getNames()[0];
  }

  setClickBehavior(config)
  {
    this.clickConfig = config;
  }

  getClickBehavior()
  {
    return this.clickConfig;
  }

  activate(name) {}

  deactivate(name) {}

  handleAction(actionArray, rayData, mouseButton)
  {
    for (var i = 0; i < actionArray.length; ++i) {
      switch (actionArray[i]) {
        case "selectOnly":
          if (this._viewerImpl.selector) {
            if (rayData) {
              this._viewerImpl.selector.setSelection([rayData.dbId], rayData.model, undefined, mouseButton);
            }
          }
          break;
        case "deselectAll":
          if (this._viewerImpl.selector) {
            this._viewerImpl.selector.setSelection([]);
          }
          break;
        case "selectToggle":
          if (this._viewerImpl.selector) {
            if (rayData) {
              this._viewerImpl.selector.toggleSelection(rayData.dbId, rayData.model);
            }
          }
          break;
        case "isolate":
          if (rayData) {
            this._viewerImpl.isolate(rayData.dbId);
          }
          break;
        case "showAll":
          this._viewerImpl.showAll();
          break;
        case "setCOI":
          if (rayData && rayData.intersectPoint) {
            this._utilities.setPivotPoint(rayData.intersectPoint, true, true);
            this._utilities.pivotActive(true, true);
          }
          break;
        case "hide":
          if (rayData) {
            this._viewerImpl.hide(rayData.dbId);
          }
          break;
        case "show":
          if (rayData) {
            this._viewerImpl.show(rayData.dbId);
          }
          break;
        case "toggleVisibility":
          if (rayData) {
            this._viewerImpl.toggleVisibility(rayData.dbId);
          }
          break;
        case "focus":
          // As a side effect of focus we also select
          if (this._viewerImpl.selector) {
            if (rayData) {
              this._viewerImpl.selector.setSelection([rayData.dbId], rayData.model);
            } else {
              this._viewerImpl.selector.setSelection([]);
            }
            this._utilities.fitToView();
          }
          break;
      }
    }
  }

  handleSingleClick(event, button)
  {

    // This condition handles iOS problem where on each input tap, 2 events dispatched
    // singleClick and singleTap. This condition skips any mouse related events for iOS devices
    if (isMobileDevice()) {
      return false;
    }

    const isRightBtnEnabled = this._viewerImpl.isRightBtnSelectionEnabled();

    var control = event.ctrlKey || event.metaKey;
    var shift = event.shiftKey;
    var alt = event.altKey;

    // Select with either left button or right button with isRightBtnSelectionEnabled
    if (button === 0 || button === 2 && isRightBtnEnabled) {
      let vpVec = this._viewerImpl.clientToViewport(event.canvasX, event.canvasY);
      let result = this._viewerImpl.hitTestViewport(vpVec, false);
      var key = "click";

      if (control) key += "Ctrl";
      if (shift) key += "Shift";
      if (alt) key += "Alt";

      var objectKey = result ? "onObject" : "offObject";

      if (this.clickConfig && this.clickConfig[key] && this.clickConfig[key][objectKey]) {
        this.handleAction(this.clickConfig[key][objectKey], result, button);
        return true;
      }
    } else
    if (button === 1 && shift && !alt && !control) {
      const vpVec = this._viewerImpl.clientToViewport(event.canvasX, event.canvasY);
      const result = this._viewerImpl.hitTestViewport(vpVec, false);
      if (result && result.intersectPoint)
      {
        this._utilities.setPivotPoint(result.intersectPoint, true, true);
        this._utilities.pivotActive(true, true);
        return true;
      }
    }
    return false;
  }

  handleDoubleClick(event, button)
  {
    if (this._viewerImpl.selector && button === 0)
    {
      var vpVec = this._viewerImpl.clientToViewport(event.canvasX, event.canvasY);
      var result = this._viewerImpl.hitTestViewport(vpVec, false);
      if (result) {
        this._viewerImpl.selector.setSelection([result.dbId], result.model);
      } else
      {
        this._viewerImpl.selector.clearSelection();
      }
      this._utilities.fitToView();
      return true;
    }
    if (button === 1)
    {
      this._navapi.fitBounds(false, this._utilities.getBoundingBox(true));
      this._navapi.setPivotSetFlag(false);
      return true;
    }
    return false;
  }

  handleSingleTap(event)
  {
    event.clientX = event.pointers[0].clientX;
    event.clientY = event.pointers[0].clientY;
    this._viewerImpl.api.triggerSingleTapCallback(event);

    if (Object.prototype.hasOwnProperty.call(event, "pointers") && event.pointers.length === 2)
    {
      this._navapi.setRequestHomeView(true);
      return true;
    }
    if (this._viewerImpl.selector && !this._viewerImpl.selector.selectionDisabled)
    {
      var vpVec = this._viewerImpl.clientToViewport(event.canvasX, event.canvasY);
      var result = this._viewerImpl.hitTestViewport(vpVec, false);

      if (result) {
        this._viewerImpl.selector.setSelection([result.dbId], result.model);
        this._viewerImpl.api.triggerSelectionChanged([result.dbId]);
      } else
      {
        this._viewerImpl.selector.clearSelection();
        this._viewerImpl.api.triggerSelectionChanged(null);
      }
      return true;
    }
    return false;
  }

  handleDoubleTap(event)
  {
    event.clientX = event.pointers[0].clientX;
    event.clientY = event.pointers[0].clientY;
    this._viewerImpl.api.triggerDoubleTapCallback(event);

    var result = this.handleSingleTap(event, 0);
    this._utilities.fitToView();
    return result;
  }

  handlePressHold(event)
  {
    if (event.type === "press")
    {
      event.clientX = event.pointers[0].clientX;
      event.clientY = event.pointers[0].clientY;

      return this._viewerImpl.api.triggerContextMenu(event);
    }
    return false;
  }

  handleGesture(event)
  {
    if (event.type.includes("swipe"))
    {
      event.clientX = event.pointers[0].clientX;
      event.clientY = event.pointers[0].clientY;

      return this._viewerImpl.api.triggerSwipeCallback(event);
    }
    return false;
  }

}